// extracted by mini-css-extract-plugin
export default {"columns":"submitForm_columns__rJKfV","submitContent":"submitForm_submitContent__CPJJv"};